export default __webpack_public_path__ + "static/media/screen2.bc5610cd.png";